// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as PorterStoreProductRepo from "./PorterStoreProductRepo.bs.js";
import * as DummyPorterStoreProductRepo from "./DummyPorterStoreProductRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyPorterStoreProductRepo.PorterStoreProductRepo;
  } else {
    return PorterStoreProductRepo.PorterStoreProductRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
